import { z } from 'zod';
import { PointSchema, PolygonSchema } from './geojson';

export const AlertTypeSchema = z.enum([
  'fire',
  'flood',
  'severe_weather',
  'air_quality',
  'other',
]);
export type AlertType = z.infer<typeof AlertTypeSchema>;

export const AlertSeveritySchema = z.enum(['low', 'medium', 'high', 'critical']);
export type AlertSeverity = z.infer<typeof AlertSeveritySchema>;

export const AlertStatusSchema = z.enum(['open', 'acknowledged', 'resolved']);
export type AlertStatus = z.infer<typeof AlertStatusSchema>;

export const AlertSchema = z.object({
  id: z.string().uuid(),
  type: AlertTypeSchema,
  severity: AlertSeveritySchema,
  status: AlertStatusSchema,
  title: z.string().min(1),
  description: z.string().optional(),
  location: PointSchema,
  area: PolygonSchema.optional(),
  sourceSensorId: z.string().uuid().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type Alert = z.infer<typeof AlertSchema>;
